module.exports = __webpack_public_path__ + "static/media/guaraci_lima_de_morais.47aa5d6d.jpg";